import { FormatQuoteRounded, StarRounded } from "@mui/icons-material";
import { Avatar, Box, Card, CardContent, Stack, Typography } from "@mui/material";
import { TESTIMONIALS } from "../content";
import { PageContainer, SectionHeading, sectionSx } from "./SectionLayout";

function TestimonialCard({ testimonial }) {
  return (
    <Card
      elevation={0}
      sx={{
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2.5,
        boxShadow: "0 12px 34px rgba(93, 63, 211, 0.06)",
        height: "100%"
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          p: { xs: 3, md: 3.5 },
          "&:last-child": { pb: { xs: 3, md: 3.5 } }
        }}
      >
        <FormatQuoteRounded sx={{ color: testimonial.accent, fontSize: 42, opacity: 0.25 }} />
        <Typography
          color="text.secondary"
          sx={{ fontSize: 14, fontStyle: "italic", lineHeight: 1.75, mb: 3.5, mt: 1 }}
        >
          "{testimonial.quote}"
        </Typography>
        <Stack direction="row" spacing={1.5} alignItems="center" mt="auto">
          <Avatar src={testimonial.image} alt={testimonial.name} sx={{ height: 48, width: 48 }} />
          <Box>
            <Typography sx={{ fontSize: 13, fontWeight: 800 }}>{testimonial.name}</Typography>
            <Typography color="text.secondary" sx={{ fontSize: 11 }}>
              {testimonial.role}
            </Typography>
            <Stack direction="row" mt={0.5}>
              {Array.from({ length: 5 }).map((_, index) => (
                <StarRounded key={index} sx={{ color: "#f4b740", fontSize: 14 }} />
              ))}
            </Stack>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
}

export default function TestimonialsSection() {
  return (
    <Box component="section" sx={sectionSx}>
      <PageContainer>
        <SectionHeading title="Loved by Recruiters and Candidates" />
        <Box
          sx={{
            display: "grid",
            gap: 2.5,
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, minmax(0, 1fr))",
              lg: "repeat(3, minmax(0, 1fr))"
            }
          }}
        >
          {TESTIMONIALS.map((testimonial, index) => {
            const isLastTestimonial = index === TESTIMONIALS.length - 1;

            return (
              <Box
                key={testimonial.name}
                sx={{
                  gridColumn: isLastTestimonial ? { sm: "1 / -1", lg: "auto" } : "auto",
                  justifySelf: "center",
                  maxWidth: isLastTestimonial ? { sm: 520, lg: "none" } : "none",
                  width: "100%"
                }}
              >
                <TestimonialCard testimonial={testimonial} />
              </Box>
            );
          })}
        </Box>
      </PageContainer>
    </Box>
  );
}
